var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.webjet)?_c('div',{directives:[{name:"attach",rawName:"v-attach:attach",arg:"attach"}],staticClass:"minimap-webjet",class:_vm.classes,style:(_vm.styles)}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }